(function () {
    'use strict';
    EO_TimeRangeV2Controller.$inject = ['$scope', '$attrs', '$element'];

    function EO_TimeRangeV2Controller($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.disableEndTime = false;
        $ctrl.allDay = false;
        $ctrl.allDay_changed = allDay_changed;


        if ($ctrl.lockEndTime != undefined && $ctrl.lockEndTime) {
            $ctrl.disableEndTime = true;
        }

        function allDay_changed() {
            if ($ctrl.allDay) {
                var startTimeValue = new Date(1970, 0, 1, 0, 0, 0);
                var endTimeValue = new Date(1970, 0, 1, 23, 59, 0);

                $ctrl.startTime = startTimeValue;
                $ctrl.endTime = endTimeValue;
            } else {
                var startTimeValue = new Date(1970, 0, 1, 8, 0, 0);
                var endTimeValue = new Date(1970, 0, 1, 17, 0, 0);

                $ctrl.startTime = startTimeValue;
                $ctrl.endTime = endTimeValue;
            }
        }


        $scope.$watch('$ctrl.startTime', function () {

            if ($ctrl.duration && $ctrl.startTime) {
                $ctrl.endTime = moment($ctrl.startTime).add($ctrl.duration, 'm').toDate();
            }
        });

    }


    var EO_TimeRangeV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/time-range-v2/eyeson.time-range-v2.template.html',
        controller: EO_TimeRangeV2Controller,
        bindings: {
            startTime: '=',
            endTime: '=',
            duration: '=?',
            lockEndTime: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('eoTimeRangeV2', EO_TimeRangeV2)


})();

